import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateFormatEnum } from '../../../enum/date-format.enum';
import { LoyaltyCardTypeModel } from '../../../models/entity/loyalty/loyalty-card-type.model';
import { LoyaltyCardModel } from '../../../models/entity/loyalty/loyalty-card.model';
import { AlertifyService } from '../../../services/core/alertify.service';
import { LoyaltyCardTypeService } from '../../../services/loyalty/loyalty-card-type.service';
import { LoyaltyCardService } from '../../../services/loyalty/loyalty-card.service';

@Component({
  selector: 'app-loyalty-card-add-update',
  templateUrl: './loyalty-card-add-update.component.html',
  styleUrls: ['./loyalty-card-add-update.component.css']
})
export class LoyaltyCardAddUpdateComponent implements OnInit {
  @Input() data: LoyaltyCardModel;
  @Input() disableCardNumber: boolean = false;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  loyaltyCardTypes: LoyaltyCardTypeModel[] = [];
  dateFormatEnum = DateFormatEnum;

  constructor(
    private loyaltyCardService: LoyaltyCardService,
    private loyaltyCardTypeService: LoyaltyCardTypeService,
    private translate: TranslateService,
    private alertifyService: AlertifyService) { }

  ngOnInit(): void {
    if (this.data) {
    }
    else {
      this.data = new LoyaltyCardModel();
    }
    this.getCardTypes();
  }

  getCardTypes() {
    this.loyaltyCardTypeService.getLoyaltyCardTypes().subscribe(
      (res) => {
        this.loyaltyCardTypes = res;
      },
      (err) => {
        this.alertifyService.error(err);
      }
    );
  }

  //güncelle veya yeni kayıt ekle
  save() {
    if (!this.validateSave())
      return;


    //Yeni kayıt ise
    if (!this.data.id) {
      this.add();
    }
    //Var olan kaydı güncelle
    else {
      this.update();
    }
  }

  //kontroller
  validateSave() {

    return true;
  }

  // yeni kayıt ekle
  add() {
    this.loyaltyCardService.addLoyaltyCard(this.data).subscribe(
      (res) => {
        this.data = res;
        this.alertifyService.success(this.translate.instant('message.info.saved'));
        this.passEntry.emit(this.data);

      },
      (err) => {
        this.alertifyService.error(err);
      }
    );
  }

  // güncelle
  update() {
    this.loyaltyCardService
      .updateLoyaltyCard(this.data.id, this.data)
      .subscribe(
        (res) => {
          this.data = res;
          this.alertifyService.success(this.translate.instant('message.info.updated'));
          this.passEntry.emit(this.data);
        },
        (err) => {
          this.alertifyService.error(err);
        }
      );
  }

  close() {
    this.passEntry.emit();
  }
}
